export enum Client {
    exchangeSubgraph = 'exchangeSubgraph',
    onePieceServer = 'onePieceServer',
    distributor = 'distributor',
}
